import { ClientPortalState, ClientPortalDispatch } from "./clientPortalStore";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const useClientPortalSelector: TypedUseSelectorHook<ClientPortalState> = useSelector;
export const useClientPortalDispatch = () => useDispatch<ClientPortalDispatch>();
